import * as turf from '@turf/turf';


export const handleDrawCreate = ({
    e, 
    mapRef, 
    drawRef, 
    geoJSONData, 
    setBrushedSubcatchments, 
    setBrushedFeaturesData
} ) => {
        if (!mapRef.current) return;
        
        const map = mapRef.current?.getMap?.();
        if (!map || !drawRef.current) return;
        
        try {
            if (!e || !e.features || !Array.isArray(e.features) || e.features.length === 0) {
                console.warn('Invalid draw event or no features:', e);
                return;
            }
            
            const polygon = e.features[0];
            if (!polygon || !polygon.geometry) {
                console.warn('Invalid polygon:', polygon);
                return;
            }
            
            const newlySelectedSubcatchments = new Set();
            if (geoJSONData && geoJSONData.subcatchments && geoJSONData.subcatchments.features) {
                const subcatchments = geoJSONData.subcatchments.features;
                const bounds = map.getBounds();
                
                subcatchments.forEach(subcatchment => {
                    try {
                        if (!subcatchment || !subcatchment.geometry || !subcatchment.properties || !subcatchment.properties.NAME) {
                            return;
                        }
                        let centroid;
                        try {
                            centroid = turf.centroid(subcatchment);
                        } catch (error) {
                            console.warn('Error creating centroid for subcatchment:', error);
                            return; 
                        }
                        
                        if (!centroid || !centroid.geometry || !centroid.geometry.coordinates) {
                            return;  // Skip if centroid couldn't be calculated
                        }
                        
                        const lng = centroid.geometry.coordinates[0];
                        const lat = centroid.geometry.coordinates[1];
                        
                        if (isNaN(lng) || isNaN(lat)) {
                            return;  // Skip if coordinates are not valid numbers
                        }
                        
                        const isVisible = bounds.contains([lng, lat]);
                        
                        if (isVisible) {
                            let intersects = false;
                            try {
                                intersects = turf.booleanIntersects(polygon, subcatchment);
                            } catch (error) {
                                console.warn('Error checking intersection:', error);
                                return; 
                            }
                            
                            if (intersects) {
                                const name = subcatchment.properties.NAME;
                                newlySelectedSubcatchments.add(name);
                                
                                setBrushedSubcatchments(prev => {
                                    const newSet = new Set(prev);
                                    newSet.add(name);
                                    return newSet;
                                });
                                
                                setBrushedFeaturesData(prev => {
                                    const newData = { ...prev };
                                    newData[name] = subcatchment.properties;
                                    return newData;
                                });
                            }
                        }
                    } catch (error) {
                        console.warn('Error processing subcatchment:', error);
                    }
                });
            }
            
            if (newlySelectedSubcatchments.size > 0) {
                console.log(`Selected ${newlySelectedSubcatchments.size} subcatchments with polygon`);
            }
            
            if (drawRef.current) {
                try {
                    drawRef.current.deleteAll();
                    drawRef.current.changeMode('draw_polygon');
                } catch (error) {
                    console.warn('Error resetting drawing state:', error);
                }
            }
            
        } catch (error) {
            console.error('Error in polygon selection:', error);
            if (drawRef.current) {
                try {
                    drawRef.current.deleteAll();
                    drawRef.current.changeMode('draw_polygon');
                } catch (e) {
                    console.warn('Error cleaning up after error:', e);
                }
            }
        }
    };



export const handleDrawMouseDown = ({
    e,
    polygonMode,
    mapRef,
    drawRef
}) => {
        if (!polygonMode || !drawRef.current) return;
        
        const map = mapRef.current?.getMap?.();
        if (!map) return;
        
        const bounds = map.getBounds();
        
        if (!bounds.contains([e.lngLat.lng, e.lngLat.lat])) {
            try {
                if (drawRef.current) {
                    drawRef.current.deleteAll();
                    drawRef.current.changeMode('draw_polygon');
                }
            } catch (error) {
                console.warn('Error handling out-of-bounds drawing:', error);
            }
        }
    };


export const clearAllPolygons = (drawRef) => {
    if (!drawRef.current) return;
    
    try {
        drawRef.current.deleteAll();
        drawRef.current.changeMode('draw_polygon');
    } catch (error) {
        console.warn('Error clearing polygons:', error);
    }
};


export const handleMouseDown = (setMouseDown) => {
    setMouseDown(true);
};

export const handleMouseUp = (setMouseDown) => {
    setMouseDown(false);
};



export const handleMapClickWithBrush = ({
    e,
    editMode,
    brushMode,
    eraserMode,
    mapRef,
    setBrushedSubcatchments,
    setBrushedFeaturesData
}) => {
        if (!editMode) return;
        console.log('handleMapClickWithBrush');
        if (!brushMode && !eraserMode) return;
        if (!mapRef.current) return;

        const map = mapRef.current?.getMap?.();
        if (!map) return;

        const point = [e.lngLat.lng, e.lngLat.lat];

        const features = map.queryRenderedFeatures(map.project(point), {
            layers: ['subcatchments'],
        });

        if (features.length > 0) {
            const feature = features[0];
            const name = feature.properties.NAME;

            setBrushedSubcatchments((prev) => {
                const newSet = new Set(prev);
                eraserMode ? newSet.delete(name) : newSet.add(name);
                return newSet;
            });

            setBrushedFeaturesData((prev) => {
                const newData = { ...prev };
                eraserMode ? delete newData[name] : newData[name] = feature.properties;
                return newData;
            });
        }
    };
